import i18n from 'i18next'
import { useLangContext } from 'store/useLangContext'
import { LanguageSubscriber } from 'utils/api/Languages/types'
type FieldTypes = string | string[]
type Fields = Record<string, FieldTypes>
type Translation<T extends Fields> = Record<string, T>

export function useGetObjectTranslation<T extends Fields, K extends keyof T>(
  translation: Translation<T> | undefined,
  field: K,
  subscriberLanguages?: LanguageSubscriber[]
): T[K]

export function useGetObjectTranslation<T extends Fields>(
  translation: Translation<T> | undefined,
  subscriberLanguages?: LanguageSubscriber[]
): T

// eslint-disable-next-line complexity
export function useGetObjectTranslation<T extends Fields, K extends keyof T>(
  translation: Translation<T> | undefined,
  field?: K,
  subscriberLanguages?: LanguageSubscriber[]
): T | T[K] | string {
  const { languages } = subscriberLanguages ? { languages: subscriberLanguages } : useLangContext()
  const defaultLangCode = languages?.find((lang) => lang.default)?.language.code
  const englishLangCode = 'en'
  if (!translation) return '' as T[K]

  const getLangTranslation = (lang: string) => translation[lang] ?? undefined

  const selectedLang = getLangTranslation(i18n.language)
  const enTranslation = getLangTranslation(englishLangCode)
  const defaultLang = getLangTranslation(defaultLangCode)
  const getFirstLang = getLangTranslation(Object.keys(translation)[0])

  if (field) {
    const getIfHasContent = (translation: T) => (translation?.[field]?.length > 0 ? translation[field] : undefined)

    return (
      getIfHasContent(selectedLang) ||
      getIfHasContent(enTranslation) ||
      getIfHasContent(defaultLang) ||
      getIfHasContent(getFirstLang) ||
      ''
    )
  }
  return selectedLang ?? defaultLang ?? enTranslation ?? getFirstLang ?? ({} as T)
}
